import {getCartQuantity, getCartTotalPrice} from '@/helpers/manage-cart';

export default {
  getCartTotalPrice: state => getCartTotalPrice(state.cart),
  getCartQuantity: state => getCartQuantity(state.cart),
}
